import { IconProps } from "../../utils/global-types/global-types";

const StarIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 10"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_2023_5148)">
        <g clipPath="url(#clip1_2023_5148)">
          <path
            fill="currentColor"
            d="M9.236 3.78a.47.47 0 0 0-.406-.325l-2.566-.233L5.25.848a.473.473 0 0 0-.87 0L3.368 3.222.8 3.455a.473.473 0 0 0-.268.827l1.94 1.7-.573 2.52a.472.472 0 0 0 .703.51L4.815 7.69l2.212 1.323a.472.472 0 0 0 .704-.51l-.572-2.52 1.94-1.7a.47.47 0 0 0 .137-.502"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2023_5148">
          <path fill="#fff" d="M0 0h10v10H0z"></path>
        </clipPath>
        <clipPath id="clip1_2023_5148">
          <path fill="#fff" d="M.37.37h8.89v8.89H.37z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default StarIcon;
